// localStorage outlives a session. These keys hold one signed-in user's chat or the ids they last picked, so they must
// not reach the next person who signs in on the same browser (DT-1521): the chat page restored the previous user's
// messages, and their conversation id made every chat call answer 403.
// Every localStorage key the app writes must be listed in one of the lists below; userScopedStorage.keys.test.js fails
// on an unlisted one, so a new per-user key cannot be forgotten.

// Cleared on every logout (and when a different user signs in)
export const SESSION_KEYS = [
  'chatMessages',            // ChatInterface: the chat transcript (questions, answers, report HTML)
  'currentConversationId',   // ChatInterface
  'selectedBrandId',         // ChatInterface, BrandContext
  'selectedExpertId',        // ChatInterface
  'selectedSubsidiaryId',    // SubsidiaryContext
  'expertsSelectedBrandId',  // ExpertsPage
  'expertsSelectedExpertId', // ExpertsPage
  'tpw.filterBrandId',       // TrustPointWizard
  'tpw.filterWarehouse',     // TrustPointWizard
  'user',                    // authService / companyService: profile JSON (name, email)
  'company',                 // authService / companyService: company JSON
];

// The user's own content, kept across their own logouts; cleared only when a different user signs in
export const PER_USER_PREFIXES = ['savedViews:']; // SavedViews: named filter views

// Not user data: the session token itself (removed by every logout path) and UI preferences
export const PREFERENCE_KEYS = ['token', 'aiProvider', 'tabContainerHeight', 'tpw.includeBundles', 'tpw.hideProcessed'];

// The call-centre agent login is a separate session with its own logout (CallCentreDashboard); not cleared here
export const SEPARATE_LOGIN_KEYS = ['agentToken', 'agentInfo', 'callCentre_slackUserId'];

const OWNER_KEY = 'userScopedStorageOwner';

export function clearSessionStorageKeys() {
  SESSION_KEYS.forEach(key => localStorage.removeItem(key));
}

// Call before the signed-in user is set, so nothing renders from another user's keys. If the keys were written for
// someone else, clear them (and that user's saved views) and record this user as the owner. Keys written before this
// release carry no owner: their session keys are cleared, but saved views are kept (they predate the owner record and
// are lower risk than the chat). Without a user id nothing can be checked, so the session keys are cleared.
export function claimUserScopedStorage(userId) {
  if (userId === undefined || userId === null || userId === '') {
    console.warn('[userScopedStorage] signed-in user has no id; clearing the session keys');
    clearSessionStorageKeys();
    return;
  }
  const owner = String(userId);
  const previousOwner = localStorage.getItem(OWNER_KEY);
  if (previousOwner === owner) return;
  clearSessionStorageKeys();
  if (previousOwner !== null) {
    Object.keys(localStorage)
      .filter(key => PER_USER_PREFIXES.some(prefix => key.startsWith(prefix)))
      .forEach(key => localStorage.removeItem(key));
  }
  localStorage.setItem(OWNER_KEY, owner);
}
